import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Grid } from '@material-ui/core';
import clsx from 'clsx'; // Optional for easier class management

export const SortableGridItem = ({ children, id, xs = 12, sm = 6, md = 4, lg }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 'auto',
    background: isDragging ? '#f9f9f9' : '#f6f7f8',
    pointerEvents: isDragging ? 'none' : 'auto', // Disable interactions
  };

  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      ref={setNodeRef}
      className={clsx({ Dragging: isDragging })}
      style={style}
      {...attributes}
      {...listeners}
    >
      {children}
    </Grid>
  );
};

SortableGridItem.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
};

SortableGridItem.defaultProps = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: undefined,
};

export default SortableGridItem;
